
<template>
  <div cy-id="artist-search">
    <v-row>
      <v-col sm="12">
        <v-text-field label="Spotify artist id" v-model="query"></v-text-field>
      </v-col>
    </v-row>
    <BuilderArtistTile v-model="query">
      <v-btn color="green" dark slot="button" @click="add" cy-id="add">
        Add
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </BuilderArtistTile>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import BuilderArtistTile from './BuilderArtistTile.vue'

@Component({
  components: { BuilderArtistTile }
})
export default class BuilderArtistSearch extends Vue {
  query = ''

  add () {
    this.$emit('add', this.query)

    this.query = ''
  }
}
</script>

<style scoped></style>
